/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Aggregated summary of discounts.
 * @export
 * @interface SAPDiscountSummary
 */
export interface SAPDiscountSummary {
    /**
     * Discount group.
     * @type {string}
     * @memberof SAPDiscountSummary
     */
    group?: string;
    /**
     * Target items to which the discounts in this summary apply. Content of this field is determined by the pricing engine, for example whether line items or additional costs are discounted.
     * @type {Set<string>}
     * @memberof SAPDiscountSummary
     */
    appliedTo?: Set<string>;
    /**
     * Total discount amount.
     * @type {number}
     * @memberof SAPDiscountSummary
     */
    amount?: number;
    /**
     * Internationalization key for the discount summary description, used on the storefront to show a human-readable label.
     * @type {string}
     * @memberof SAPDiscountSummary
     */
    descriptionKey?: string;
}

/**
 * Check if a given object implements the SAPDiscountSummary interface.
 */
export function instanceOfSAPDiscountSummary(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPDiscountSummaryFromJSON(json: any): SAPDiscountSummary {
    return SAPDiscountSummaryFromJSONTyped(json, false);
}

export function SAPDiscountSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPDiscountSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'group': !exists(json, 'group') ? undefined : json['group'],
        'appliedTo': !exists(json, 'appliedTo') ? undefined : json['appliedTo'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'descriptionKey': !exists(json, 'descriptionKey') ? undefined : json['descriptionKey'],
    };
}

export function SAPDiscountSummaryToJSON(value?: SAPDiscountSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'group': value.group,
        'appliedTo': value.appliedTo === undefined ? undefined : Array.from(value.appliedTo as Set<any>),
        'amount': value.amount,
        'descriptionKey': value.descriptionKey,
    };
}

